import dynamicfunction from '../../../../utils/dynamicfunction';

const ViewItems = ({ children, className }) => {
  const { isArabic } = dynamicfunction();

  return (
    <div
      className={`flex flex-col ${isArabic ? 'justify-items-end' : 'justify-items-start'
        } ${className ?? ''}`}
    >
      {children}
    </div>
  );
};

export default ViewItems;
